/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Launch_Your_StorefrontInputs */

const en_launch_your_storefront = /** @type {(inputs: Launch_Your_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`launch your storefront`)
};

const es_launch_your_storefront = /** @type {(inputs: Launch_Your_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lanza tu tienda`)
};

const fr_launch_your_storefront = /** @type {(inputs: Launch_Your_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lancez votre vitrine`)
};

const de_launch_your_storefront = /** @type {(inputs: Launch_Your_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`starte deine Storefront`)
};

const ja_launch_your_storefront = /** @type {(inputs: Launch_Your_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストアフロントを立ち上げてください`)
};

const zh_launch_your_storefront = /** @type {(inputs: Launch_Your_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启动您的店铺`)
};

const ar_launch_your_storefront = /** @type {(inputs: Launch_Your_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أطلق واجهة متجرك`)
};

const id_launch_your_storefront = /** @type {(inputs: Launch_Your_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`luncurkan etalase Anda`)
};

const it_launch_your_storefront = /** @type {(inputs: Launch_Your_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lancia la tua vetrina`)
};

const ru_launch_your_storefront = /** @type {(inputs: Launch_Your_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`запустите свою витрину`)
};

const pt_launch_your_storefront = /** @type {(inputs: Launch_Your_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lance a sua vitrine`)
};

const ko_launch_your_storefront = /** @type {(inputs: Launch_Your_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스토어프론트 런칭하기`)
};

/**
* | output |
* | --- |
* | "launch your storefront" |
*
* @param {Launch_Your_StorefrontInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const launch_your_storefront = /** @type {((inputs?: Launch_Your_StorefrontInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Launch_Your_StorefrontInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_launch_your_storefront(inputs)
	if (locale === "es") return es_launch_your_storefront(inputs)
	if (locale === "fr") return fr_launch_your_storefront(inputs)
	if (locale === "de") return de_launch_your_storefront(inputs)
	if (locale === "ja") return ja_launch_your_storefront(inputs)
	if (locale === "zh") return zh_launch_your_storefront(inputs)
	if (locale === "ar") return ar_launch_your_storefront(inputs)
	if (locale === "id") return id_launch_your_storefront(inputs)
	if (locale === "it") return it_launch_your_storefront(inputs)
	if (locale === "ru") return ru_launch_your_storefront(inputs)
	if (locale === "pt") return pt_launch_your_storefront(inputs)
	return ko_launch_your_storefront(inputs)
});